import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    zIndex: -2,
    top: -120,
    left: 0,
    height: '380px',
    overflow: 'hidden',
    width: '100%',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), radial-gradient(142.16% 142.16% at 33.37% -35.39%, #E277EE 8.93%, #5E2FBB 73.54%, #382751 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;',
  },
  background: {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  },
  xs: {
    height: '20vh',
  },
  large: {
    height: '500px',
    [theme.breakpoints.down('sm')]: {
      height: '400px',
    },
  },
  regular: {
    height: '350px',
    [theme.breakpoints.down('sm')]: {
      height: '300px',
    },
  },
  small: {
    height: '18vh',
  },
  xl: {
    [theme.breakpoints.down('sm')]: {
      height: '500px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '560px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '700px',
    },
    height: '600px',
  },
  xxl: {
    height: 'calc(100% + 120px)',
  },
}))

function Background({
  size,
}: {
  size?: 'xs' | 'small' | 'regular' | 'large' | 'xl' | 'xxl'
}): JSX.Element {
  const classes = useStyles({})
  return <div className={`${classes.root} ${size && classes[size]}`}></div>
}

export default Background
